export default "__VITE_ASSET__CavPOJIy__"